import { normalize } from 'polished'
import { createGlobalStyle, css } from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const styles = css`
  ${normalize()}

  @import url('https://fonts.googleapis.com/css?family=Catamaran|Playfair+Display&display=swap');

  html,
  body {
    color: ${props => props.theme.palette.general.strong};
    font: ${font('default', 'light', '18px/1.25rem')};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  ::selection {
    color: ${props => props.theme.palette.general.light};
    background: ${props => props.theme.palette.general.dark};
  }

  .form-error {
    font-size: 18px;
    bottom: calc(30px - 2.1em);
  }
`

export const GlobalStyle = createGlobalStyle`
  ${styles}
`
